module.exports = __webpack_public_path__ + "img/NWarDogs64_ua.1701b103.webp";